import m from 'mithril';
import input from '../../components/input'

const modal = {
  key: 'ADD_TEAM_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state, attrs }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Create a Team'),
                    m('button.close[type="button" data-dismiss="modal" aria-label="close"', {
                      onclick() {
                        modal.hide();
                      },
                    },
                      [
                        m('span[aria-hidden="true"]', '×'),
                      ]),
                  ]),
                m('.modal-body',
                  [
                    m(input, {
                      label: 'Name of the team',
                      value:state.name,
                      oninput(v) {
                        state.name = v
                      }
                    })
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-secondary[type="button]', {
                      onclick() {
                        modal.hide();
                      },
                    }, 'Close'),
                    m(`button.btn.btn-primary${state.loading === true ? '.k-spinner.k-spinner--v2.k-spinner--right.k-spinner--lg.k-spinner--success' : ''}`, {
                      async onclick() {
                        state.loading = true;

                        m.redraw();

                        await attrs.add({
                          name: state.name,
                        })

                        state.name = ""
                        // some async tings
                        state.loading = false;
                        m.redraw();
                        modal.hide();
                      },
                    },
                      'Save'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
